import { Button, Icon } from "components/lib";
import { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import "./app.scss";
import logo from "./images/SmallLogo.png";

export function AppNav(props) {
  // state
  const [open, setOpen] = useState(false); // mobile is open
  const [expanded, setExpanded] = useState(true); // desktop is expanded
  const [items, setItems] = useState(props.items);

  useEffect(() => {
    setItems(props.items);
  }, [props.items]);

  return (
    <nav
      className={`sidebar popup expanded`}
      onMouseEnter={(e) => setExpanded(true)}
      onMouseLeave={(e) => {
        setExpanded(false);
        setOpen(false);
      }}
    >
      <Button
        icon={open ? "x" : "menu"}
        color={"dark"}
        size={12}
        className="btn-togglenav"
        action={(e) => setOpen(!open)}
      />

      <div
        style={{ display: "flex", justifyContent: "center", paddingTop: 10 }}
      >
        <img src={logo} style={{ width: 80, marginTop: 10 }} />
      </div>
      <section className="nav-links">
        <main>
          {items?.map((item) => {
            if (item.link) {
              return (
                <NavLink
                  key={item.label}
                  to={item.link}
                  style={{ width: 100 / items.length + "%" }}
                >
                  {item.itemsCount > 0 ? (
                    <span className="items-count">{item.itemsCount}</span>
                  ) : (
                    item.icon && (
                      <Icon
                        className="icon"
                        image={item.icon}
                        size={open ? 15 : 18}
                        color={open ? "dark" : "light"}
                      />
                    )
                  )}
                  {item.label && <span className="label">{item.label}</span>}
                </NavLink>
              );
            }

            return (
              <div key={item.label} onClick={item.action}>
                {item.itemsCount > 0 ? (
                  <span className="items-count">{item.itemsCount}</span>
                ) : (
                  item.icon && (
                    <Icon
                      className="icon"
                      image={item.icon}
                      size={open ? 15 : 18}
                      color={open ? "dark" : "light"}
                    />
                  )
                )}
                {item.label && <span className="label">{item.label}</span>}
              </div>
            );
          })}
        </main>
        <main style={{ marginBottom: 50 }}>
          {props.fixedItems?.map((item) => {
            if (item.link) {
              return (
                <NavLink
                  key={item.label}
                  to={item.link}
                  style={{ width: 100 / props.fixedItems.length + "%" }}
                >
                  {item.itemsCount > 0 ? (
                    <span className="items-count">{item.itemsCount}</span>
                  ) : (
                    item.icon && (
                      <Icon
                        className="icon"
                        image={item.icon}
                        size={open ? 15 : 18}
                        color={open ? "dark" : "light"}
                      />
                    )
                  )}
                  {item.label && <span className="label">{item.label}</span>}
                </NavLink>
              );
            }

            return (
              <div key={item.label} onClick={item.action}>
                {item.itemsCount > 0 ? (
                  <span className="items-count">{item.itemsCount}</span>
                ) : (
                  item.icon && (
                    <Icon
                      className="icon"
                      image={item.icon}
                      size={open ? 15 : 18}
                      color={open ? "dark" : "light"}
                    />
                  )
                )}
                {item.label && <span className="label">{item.label}</span>}
              </div>
            );
          })}
        </main>
      </section>
    </nav>
  );
}